import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'bgUrl',
})
export class BgUrlPipe implements PipeTransform {

  transform(value: string | undefined): any {


    if (!value) {
      return {backgroundImage: `url()`}
    }


    return {
      backgroundImage: `url('${value}')`,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat'

    }

  }


}
